import React from 'react'
import clsx from 'clsx'
import { progress, percent } from '../helpers'

const ProgressBar = ({ points, className }) => {
  const stats = progress(points)

  return (
    <div className={clsx('h-1.5 overflow-hidden rounded-full bg-slate-100', className)}>
      <div
        className={clsx('h-full rounded-full transition-all', stats.complete ? 'bg-emerald-500' : 'bg-brand-500')}
        style={{ width: `${percent(stats)}%` }}
      />
    </div>
  )
}

export default ProgressBar
